import React from 'react';
import Box from '@mui/material/Box';
import { HeaderTitle } from './style';

export default function ListItems({ children, title }) {
  return (
    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      <HeaderTitle>{title}</HeaderTitle>
      <nav aria-label="main mailbox folders">{children}</nav>
    </Box>
  );
}
